module.exports = __webpack_public_path__ + "static/media/recognize.fbe20448.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Dental Health/recognize.png
// module id = 309
// module chunks = 0